import { useState, useEffect } from 'react';
import Api from 'entities/helpers/api';

/**
 * Fetches the user's saved searches (dynamic lists) from the contacts API.
 * Dynamic lists have a tag_id (Tags service) that differs from the list id
 * (contacts service). The saved_search_sync backend needs the tag_id; the
 * cadences saved-search refresh workflow needs the contacts list id (so it
 * can call the contacts list-tag-operation API to re-evaluate membership).
 * Each option carries both.
 *
 * Used by cadence, prospect plan, and bulk message creation pages for recipient selection.
 */
const useSavedSearches = () => {
  const [searches, setSearches] = useState([]);
  useEffect(() => {
    Api.CONTACTS.LISTS.get({ params: { limit: 200, type: 'dynamic' } })
      .then((resp) => {
        const items = (resp?.items || [])
          .filter((item) => item.tag_id)
          .map((item) => ({
            label: item.name,
            value: String(item.tag_id),
            count: item.contact_count || 0,
            // listId is the contacts-system list id; needed downstream so
            // mutations can submit savedSearchListId / saved_search_list_id.
            listId: item.id || null,
          }));
        setSearches(items);
      })
      .catch(() => setSearches([]));
  }, []);
  return searches;
};

export default useSavedSearches;
